
















import { Component, Vue } from 'vue-property-decorator';
import { sessionModule } from '@/trials/store/modules/session';
import { SysConst as SC } from '@/trials/plugins/const';

import ErrorDialogData from '@/trials/exceptions/errorDialogData';

@Component
export default class ErrorDialog extends Vue {
    /*----------------------------------*
     * 変数
     *-----------------------------------*/
    private width: number = SC.Dialog.WIDTH;

    /*----------------------------------*
     * props
     *-----------------------------------*/

    /*----------------------------------*
     * ライフサイクルフック
     *-----------------------------------*/

    /*----------------------------------*
     * Computed
     *-----------------------------------*/
    public get dialogData(): ErrorDialogData | null {
        return sessionModule.getErrorDialogData;
    }
    public get isShow(): boolean {
        return this.dialogData !== null;
    }
    public get title(): string {
        return this.dialogData !== null ? this.dialogData.title : '';
    }
    public get messageKey(): string {
        return this.dialogData !== null ? this.dialogData.messageKey : '';
    }

    /*----------------------------------*
     * Methods
     *-----------------------------------*/
    private closeDialog(): void {
        sessionModule.closeErrorDialog();
    }
}
